export const comments_3374308 = {"data":{"data":[],"links":{}}}